<mat-checkbox
  [checked]="checked"
  [disabled]="disabled"
  (change)="onChecked($event)"
  [color]="'primary'"
>
    {{ label }}
</mat-checkbox>
